(function(){
  var root = document.getElementById('coReportV3');
  if(!root) return;

  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-screen]'));
  var state = {
    answers: {},
    history: [],
    current: null
  };

  var TOTAL_STEPS = 18;

  var questions = {
    stage: {
      kicker: 'Home buying stage',
      micro: 'Let’s start with where you are today.',
      title: 'Where are you in the home-buying process?',
      copy: 'Timeline changes the risk. Someone under contract needs a different plan than someone preparing early.',
      choices: [
        ['research', 'Just researching', ''],
        ['12m', 'Within 12 months', ''],
        ['6m', 'Within 6 months', ''],
        ['lender', 'Already speaking with a lender', ''],
        ['contract', 'Already under contract', '']
      ],
      next: function(v){ return (v === 'lender' || v === 'contract') ? 'lenderTarget' : 'mortgageScore'; }
    },

    lenderTarget: {
      kicker: 'Lender target',
      micro: 'If a lender gave you a target, we should build around it.',
      title: 'Did your lender give you a target score?',
      copy: 'A target score can be useful, but the path to reach it is often not explained clearly.',
      choices: [
        ['yes', 'Yes', 'They told me a score to reach.'],
        ['no', 'No', 'They did not give me a target score.'],
        ['unclear', 'They were not clear', 'I’m not sure what target matters.']
      ],
      next: function(v){ return v === 'yes' ? 'targetScore' : 'mortgageScore'; }
    },

    targetScore: {
      kicker: 'Target score',
      micro: 'Now we know the destination.',
      title: 'What score did they tell you to reach?',
      copy: 'This helps separate a score-gap issue from a balance, history, or file issue.',
      choices: [
        ['under620', 'Under 620', ''],
        ['620', '620–679', ''],
        ['680', '680–719', ''],
        ['720', '720+', ''],
        ['740', '740+', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'mortgageScore'; }
    },

    mortgageScore: {
      kicker: 'Mortgage score reality',
      micro: 'This is a common home-buying blind spot.',
      title: 'Do you know your mortgage-specific credit scores?',
      copy: 'App scores and online scores may not match the mortgage scores a lender uses.',
      choices: [
        ['mortgage_fico', 'Yes, I checked mortgage-specific FICO scores', ''],
        ['app_score', 'I only know my app / online score', ''],
        ['one_bureau', 'I know one bureau score', ''],
        ['not_sure', 'I’m not sure', '']
      ],
      next: function(){ return 'scoreRange'; }
    },

    scoreRange: {
      kicker: 'Score range',
      micro: 'This is only one part of the picture.',
      title: 'Roughly where do you think your score is today?',
      copy: 'We’ll use this as a direction, not as a final mortgage result.',
      choices: [
        ['740', '740+', ''],
        ['700', '700–739', ''],
        ['660', '660–699', ''],
        ['620', '620–659', ''],
        ['under620', 'Under 620', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'cardsTotal'; }
    },

    cardsTotal: {
      kicker: 'Credit card structure',
      micro: 'First we need the structure of your revolving accounts.',
      title: 'How many credit cards do you currently have?',
      copy: 'A file with two cards is different from a file with ten cards.',
      choices: [
        ['0-1', '0–1 cards', ''],
        ['2-3', '2–3 cards', ''],
        ['4-6', '4–6 cards', ''],
        ['7-10', '7–10 cards', ''],
        ['10+', '10+ cards', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'cardsBalance'; }
    },

    cardsBalance: {
      kicker: 'Balance pattern',
      micro: 'This is where many buyers get surprised.',
      title: 'How many cards currently report a balance?',
      copy: 'It is not only total debt. It can also matter how many accounts are actively reporting balances.',
      choices: [
        ['0', 'None', ''],
        ['1', '1 card', ''],
        ['2-3', '2–3 cards', ''],
        ['4+', '4+ cards', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(v){ return v === '0' ? 'lates' : 'over50'; }
    },

    over50: {
      kicker: 'Utilization pressure',
      micro: 'Now we’re checking individual card pressure.',
      title: 'Do any cards report above 50% of their limit?',
      copy: 'A single high card can matter even when the total debt does not look extreme.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'over90'; }
    },

    over90: {
      kicker: 'High utilization',
      micro: 'This is more serious than simply being over 50%.',
      title: 'Do any cards report above 90% of their limit?',
      copy: 'Cards near the limit can create heavy score pressure and may deserve priority review.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'maxedOut'; }
    },

    maxedOut: {
      kicker: 'Maxed-out cards',
      micro: 'This is one of the highest pressure balance patterns.',
      title: 'Are any cards currently maxed out?',
      copy: 'A maxed-out card can be a major score killer and may need a different order of operations.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'overLimit'; }
    },

    overLimit: {
      kicker: 'Over-limit risk',
      micro: 'This can be even more urgent than high utilization.',
      title: 'Are any cards currently over the limit?',
      copy: 'Over-limit cards can create serious score pressure and may also create lender concern.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'lates'; }
    },

    lates: {
      kicker: 'Payment history',
      micro: 'Payment history can outrank other issues.',
      title: 'Have you had any late payments in the last 24 months?',
      copy: 'Recent late payments can affect mortgage readiness even when the score looks acceptable.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(v){ return v === 'yes' ? 'lateType' : 'collections'; }
    },

    lateType: {
      kicker: 'Late type',
      micro: 'The account type matters.',
      title: 'What type of account was the late payment on?',
      copy: 'A mortgage late can be treated differently than a credit card, auto, or student loan late.',
      choices: [
        ['mortgage', 'Mortgage', ''],
        ['auto', 'Auto loan', ''],
        ['card', 'Credit card', ''],
        ['student', 'Student loan', ''],
        ['personal', 'Personal loan', ''],
        ['multiple', 'Multiple account types', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'lateRecent'; }
    },

    lateRecent: {
      kicker: 'Late recency',
      micro: 'Recency changes priority.',
      title: 'How recent was the most recent late payment?',
      copy: 'A recent late can move above balances in the priority order.',
      choices: [
        ['0-6', 'Within 6 months', ''],
        ['6-12', '6–12 months ago', ''],
        ['12-24', '12–24 months ago', ''],
        ['older', 'Older than 24 months', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'collections'; }
    },

    collections: {
      kicker: 'Collections',
      micro: 'Now we’re checking for items that may need review before action.',
      title: 'Any collections or charge-offs you know about?',
      copy: 'The first question is not always whether to pay it. It is whether it is yours, accurate, and how it is reporting.',
      choices: [
        ['yes', 'Yes', ''],
        ['no', 'No', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(v){ return v === 'yes' ? 'recognizeCollection' : 'fileAccuracy'; }
    },

    recognizeCollection: {
      kicker: 'Collection recognition',
      micro: 'This matters before deciding what to do next.',
      title: 'Do you recognize the collection account?',
      copy: 'If you do not recognize it, the next path may involve identity or reporting review.',
      choices: [
        ['yes', 'Yes, I recognize it', ''],
        ['no', 'No, I do not recognize it', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'collectionType'; }
    },

    collectionType: {
      kicker: 'Collection type',
      micro: 'Different collection types can create different concerns.',
      title: 'What type of collection is it?',
      copy: 'This helps decide whether the next step is status review, documentation, or identity/reporting review.',
      choices: [
        ['medical', 'Medical', ''],
        ['utility', 'Utility or telecom', ''],
        ['credit', 'Credit account', ''],
        ['rental', 'Rental or housing', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'fileAccuracy'; }
    },

    fileAccuracy: {
      kicker: 'Credit file accuracy',
      micro: 'This is a detail many buyers never check.',
      title: 'Have you reviewed the personal information section of your credit reports?',
      copy: 'Incorrect name spelling, addresses, DOB, or unknown accounts can sometimes point to file matching issues, split files, mixed files, or identity concerns.',
      choices: [
        ['correct', 'Everything appears correct', ''],
        ['wrong_name', 'My name is misspelled or inconsistent', ''],
        ['wrong_address', 'There are incorrect or unfamiliar addresses', ''],
        ['wrong_dob', 'My date of birth or personal info looks wrong', ''],
        ['unknown_accounts', 'I see accounts I do not recognize', ''],
        ['not_checked', 'I have not checked this yet', '']
      ],
      next: function(){ return 'recentInfoChange'; }
    },

    recentInfoChange: {
      kicker: 'Personal info changes',
      micro: 'Recent changes can sometimes create verification friction.',
      title: 'Have you recently changed your name, address, or marital status?',
      copy: 'Major personal information changes can sometimes affect bureau matching, lender verification, or document review.',
      choices: [
        ['no', 'No', ''],
        ['address', 'New address', ''],
        ['name', 'Name change', ''],
        ['marital', 'Marital status change', ''],
        ['multiple', 'Multiple recent changes', ''],
        ['not_sure', 'Not sure', '']
      ],
      next: function(){ return 'creditFreeze'; }
    },

    creditFreeze: {
      kicker: 'Credit freeze / lock',
      micro: 'This can cause avoidable mortgage delays.',
      title: 'Have you ever frozen or locked your credit reports?',
      copy: 'If a lender needs to pull credit, now is the time to make sure you can unlock your reports and access any PINs, passwords, or bureau logins.',
      choices: [
        ['yes_have_pin', 'Yes, and I know how to unlock them', ''],
        ['yes_no_pin', 'Yes, but I may not have the PIN/login', ''],
        ['no', 'No', ''],
        ['not_sure', 'Not sure', '']
      ],
      next: function(){ return 'newCredit'; }
    },

    newCredit: {
      kicker: 'New credit',
      micro: 'This matters especially before closing.',
      title: 'Have you applied for any new credit recently?',
      copy: 'Even business credit can create questions if an inquiry appears or a lender asks whether new debt was opened.',
      choices: [
        ['no', 'No', ''],
        ['personal_card', 'Personal credit card', ''],
        ['business_card', 'Business credit card', ''],
        ['auto', 'Auto loan', ''],
        ['store', 'Store card or financing', ''],
        ['loan', 'Personal loan', ''],
        ['unknown', 'Not sure', '']
      ],
      next: function(){ return 'build'; }
    }
  };

  function show(name){
    screens.forEach(function(s){ s.classList.remove('active'); });
    var el = root.querySelector('[data-screen="' + name + '"]');
    if(el) el.classList.add('active');
    setTimeout(function(){
      root.scrollIntoView({behavior:'smooth', block:'start'});
    }, 20);
  }

  function escapeHtml(str){
    return String(str || '').replace(/[&<>"']/g, function(m){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m];
    });
  }

  function renderQuestion(key){
    state.current = key;
    var q = questions[key];
    if(!q) return;

    var kicker = root.querySelector('[data-question-kicker]');
    var title = root.querySelector('[data-question-title]');
    var copy = root.querySelector('[data-question-copy]');
    var micro = root.querySelector('[data-micro]');
    var label = root.querySelector('[data-step-label]');
    var count = root.querySelector('[data-step-count]');
    var progress = root.querySelector('[data-progress]');
    var choices = root.querySelector('[data-choices]');

    if(kicker) kicker.textContent = q.kicker;
    if(title) title.textContent = q.title;
    if(copy) copy.textContent = q.copy;
    if(micro) micro.textContent = q.micro;
    if(label) label.textContent = q.kicker;

    var stepNum = Math.min(TOTAL_STEPS, state.history.length + 1);
    if(count) count.textContent = stepNum + ' of ' + TOTAL_STEPS;
    if(progress) progress.style.width = Math.min(96, Math.max(7, (stepNum / TOTAL_STEPS) * 100)) + '%';

    if(choices){
      choices.innerHTML = q.choices.map(function(c){
        var helper = c[2] ? '<span>' + escapeHtml(c[2]) + '</span>' : '';
        return '<button type="button" class="corv3-choice" data-value="' + escapeHtml(c[0]) + '"><span><strong>' + escapeHtml(c[1]) + '</strong>' + helper + '</span><i>→</i></button>';
      }).join('');
    }

    show('consult');
  }

  function runBuild(){
    show('building');

    var items = Array.prototype.slice.call(root.querySelectorAll('.corv3-buildList div'));
    items.forEach(function(x){ x.classList.remove('active','done'); });

    var i = 0;
    var timer = setInterval(function(){
      if(i > 0){
        items[i - 1].classList.remove('active');
        items[i - 1].classList.add('done');
      }

      if(i < items.length){
        items[i].classList.add('active');
        i++;
      } else {
        clearInterval(timer);
        setTimeout(function(){ window.location.href = '/pages/report-results'; }, 450);
      }
    }, 390);
  }

  root.addEventListener('click', function(e){
    if(e.target.closest('[data-start]')){
      state.answers = {};
      state.history = [];
      renderQuestion('stage');
      return;
    }

    var choice = e.target.closest('.corv3-choice');
    if(choice){
      var key = state.current;
      var val = choice.getAttribute('data-value');

      state.answers[key] = val;
      state.history.push(key);

      var next = questions[key] && questions[key].next ? questions[key].next(val) : 'build';

      if(next === 'build'){
        runBuild();
      } else {
        renderQuestion(next);
      }
      return;
    }

    if(e.target.closest('[data-back]')){
      state.history.pop();
      var previous = state.history.pop();

      if(!previous){
        state.answers = {};
        show('welcome');
        return;
      }

      renderQuestion(previous);
      return;
    }
  });
})();